import { Notification } from "@/components/admin/notification";
import { useTranslate } from "ra-core";
import { useConfigurationContext } from "../root/ConfigurationContext";
import { AuthBrandPanel } from "./AuthBrandPanel";

export const ConfirmationRequired = () => {
  const translate = useTranslate();
  const { darkModeLogo: logo, title } = useConfigurationContext();

  return (
    <div className="min-h-screen bg-[#f7f0e7] lg:flex">
      <AuthBrandPanel logo={logo} title={title} />
      <div className="flex min-h-screen w-full items-center justify-center p-5 sm:p-8 lg:w-[54%]">
        <div className="w-full max-w-[390px] rounded-[1.7rem] border border-[#eadfd2] bg-card p-7 text-center shadow-[0_18px_40px_rgba(65,48,36,0.1)] sm:p-9">
          <img
            className="mx-auto mb-6 size-12 rounded-xl object-contain"
            src={logo}
            alt={title}
          />
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#b65338]">
            One more step
          </p>
          <h1 className="mt-2 text-3xl font-semibold tracking-[-0.045em]">
            {translate("crm.auth.welcome_title", {
              _: "Welcome to Wabi Sabi",
            })}
          </h1>
          <p className="mt-4 text-sm leading-6 text-muted-foreground">
            {translate("crm.auth.confirmation_required", {
              _: "Please follow the link we just sent you by email to confirm your account.",
            })}
          </p>
        </div>
      </div>
      <Notification />
    </div>
  );
};

ConfirmationRequired.path = "/sign-up/confirm";
